import { ConfirmationModal } from '@/components/modals/ConfirmationModal/ConfirmationModal';

interface DeleteConversationConfirmationModalProps {
  isDeleting: boolean;
  onClose: (reason: 'confirm' | 'cancel') => void;
}

export function DeleteConversationConfirmationModal({
  isDeleting,
  onClose,
}: DeleteConversationConfirmationModalProps) {
  return (
    <ConfirmationModal
      isOpen
      heading="Delete conversation?"
      confirmText="Delete"
      confirmButtonProps={{
        variant: 'destructive-primary',
        loading: isDeleting,
        disabled: isDeleting,
      }}
      onClose={onClose}
    >
      This conversation and all its messages will be permanently deleted.
    </ConfirmationModal>
  );
}
